<template>
  <div>
    <a-modal
      v-model="isShow"
      title="确定打印信息"
      :width="modalWidthProp ? modalWidthProp : '1000px'"
      @cancel="back"
    >
      <template slot="footer">
        <a-button key="back" @click="back"> 取消 </a-button>
        <a-button
          v-if="title === 'pdf'"
          :loading="loadingPDF"
          type="primary"
          @click="getPdf"
        >
          导出PDF
        </a-button>
        <a-button
          v-else
          key="submit"
          type="primary"
          v-print="'#printMedd'"
          @click="back"
        >
          确定打印
        </a-button>
      </template>
      <div class="print-scrollY">
        <div id="printMedd" ref="print" class="printd">
          <div class="printd-qr" v-if="id">
            <img class="printd-qr-img" :src="qrImg" alt="" />
          </div>
          <slot></slot>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { generCode } from '@/http/url'
export default {
  props: ['isPrint', 'id', 'mobilePath', 'skipPageReqFlag', 'modalWidthProp'],
  model: {
    event: 'input',
    prop: 'isPrint'
  },
  data() {
    return {
      isShow: false,
      qrImg: '',
      loadingPDF: false,
      isPDF: true,
      title: ''
    }
  },
  mounted() {
    if (this.id && this.skipPageReqFlag && this.mobilePath) {
      // id存在
      let params = {
        businessKey: this.id,
        skipPageReqFlag: this.skipPageReqFlag,
        urlStr: this.mobilePath + this.id
      }
      generCode(params).then((res) => {
        if (res.data.code == 0) {
          this.qrImg = res.data.data.fileUrl
        }
      })
    }
    // 判断是否显示 导出pdf按钮
    if (this.$route.name === 'PersonnelDetails') {
      this.isPDF = true
    } else {
      this.isPDF = true
    }
  },
  watch: {
    isPrint: {
      handler(newVal, odlVal) {
        if (newVal.printTitle) {
          // 人事管理下打印用这个
          this.isShow = newVal.printStatus
          this.title = newVal.printTitle
        } else {
          // 常规下打印用此处
          this.isShow = newVal
        }
      },
      deep: true
    }
  },
  methods: {
    getPdf() {
      this.loadingPDF = true
      html2Canvas(document.querySelector('#printMedd'), {
        allowTaint: true
      }).then((canvas) => {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        this.$emit('input', false)
        this.loadingPDF = false
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(document.title + '.pdf')
      })
    },
    back() {
      this.$emit('input', false)
    }
  }
}
</script>

<style socped lang='scss'>
@media print {
  html {
    zoom: 73%;
  }
}
.print-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
// .print-scrollY::-webkit-scrollbar {
//   display: none;
// }
.printd-qr {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
}
.printd-qr-img {
  height: 80px;
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/print/index.vue